import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { toVoucherWriteBody } from './serialize';

/**
 * PATCH `/fms/vouchers/{id}`。
 * 僅 DRAFT；可送 totalAmount；禁送 status；含 updatedAt。
 */
export async function updateVoucher(id, payload) {
  const { data: raw } = await request.patch(
    `/fms/vouchers/${id}`,
    toVoucherWriteBody(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
